import { LARGEST_PAGE, useApi, type ClassResponse } from '@daghfal/core';
import { useQuery } from '@tanstack/react-query';

/**
 * The classes a teacher works in, and the one a class screen opens on.
 *
 * A room the teacher sees only because their own child is in it is not theirs: they are a parent there, and record
 * nothing on its board (Q52). With one class there is nothing to choose; with several, the teacher's own room is where
 * they start. The API's largest page, so a room late in the alphabet is still found in a large setting.
 */
export function useMyClasses() {
  const api = useApi();

  const classes = useQuery({
    queryKey: ['classes', { status: 'Active', pageSize: LARGEST_PAGE }],
    queryFn: () => api.classes.list({ status: 'Active', pageSize: LARGEST_PAGE }),
  });

  const mine: ClassResponse[] = (classes.data?.items ?? []).filter((klass) => klass.inStaffReach);
  const opening = mine.length === 1 ? mine[0] : mine.find((klass) => klass.isAssigned);

  return { classes, mine, opening };
}
